import { DefaultTheme } from "styled-components";

const darkTheme: DefaultTheme = {
  body: "#121620",
  text: "#f1f1f1",
};

export { darkTheme };
